'use strict';

module.exports = require('./slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.0.14.5@react-slick/lib/index.js
 ** module id = 257
 ** module chunks = 0
 **/